import { FilterResult } from 'src/app/shared/components/odata-filter/models/filter-result';
import { IPeople, People } from './people.model';

export class PeopleFilterResult implements FilterResult {
  public count: number;
  public values: People[] = [];
  public nextLink: string;
  public parse(response: any) {
    let result = new PeopleFilterResult();
    result.count = response['@odata.count'];
    result.values = response.value.map((people: IPeople) => People.parse(people));
    result.nextLink = response['@odata.nextLink'];
    return result;
  }
}
